import {
  mdiHome,
  mdiWeb,
  mdiMenuDown,
  mdiClose,
  mdiMenu,
  mdiAccount,
  mdiAccountPlus,
  mdiLogin,
  mdiLogout,
  mdiThemeLightDark,
  mdiCameraPlusOutline,
  mdiSend,
  mdiContentSave,
  mdiChevronRight,
  mdiChevronLeft,
  mdiChevronUp,
  mdiChevronDown,
  mdiHomeRemoveOutline,
  mdiCrop,
  mdiMapMarker,
  mdiHomePlusOutline,
  mdiHomePlus,
  mdiHomeLightbulbOutline,
  mdiHomeExportOutline,
  mdiHomeGroup,
  mdiHomeClock,
  mdiStar,
  mdiAccountOutline,
  mdiHeart,
  mdiShareVariant,
  mdiPencil,
  mdiCalendarAccount,
  mdiImage,
  mdiCloudUpload,
  mdiMarker,
  mdiDeleteEmpty,
  mdiEye,
  mdiEyeOff,
  mdiBell,
  mdiListStatus,
  mdiText,
  mdiHomeAccount,
  mdiTimelineQuestion,
  mdiHomeRemove,
  mdiAccountRemove,
  mdiMenuDownOutline,
  mdiMap,
  mdiHomeCity,
  mdiHomeAnalytics,
  mdiMagnifyPlus,
  mdiTimelinePlus,
  mdiEmail,
  mdiLock,
  mdiFormatListBulleted,
  mdiMagnify,
  mdiChartLine,
  mdiNewspaper,
  mdiDelete,
  mdiFilter,
  mdiInformation,
  mdiSkipNext,
  mdiSkipPrevious,
  mdiComment,
  mdiCommentOutline,
  mdiCommentEdit,
  mdiCommentEditOutline,
  mdiCheckCircle,
  mdiHeadSyncOutline,
  mdiRefresh,
  mdiMapMarkerQuestionOutline,
  mdiBullseye,
  mdiChiliHot,
  mdiCharitySearch,
} from "@mdi/js";

const icons = {
  mdiHome: mdiHome,
  mdiWeb: mdiWeb,
  mdiMenuDown: mdiMenuDown,
  mdiThemeLightDark: mdiThemeLightDark,
  mdiClose: mdiClose,
  mdiMenu: mdiMenu,
  mdiAccount: mdiAccount,
  mdiLogout: mdiLogout,
  mdiAccountPlus: mdiAccountPlus,
  mdiLogin: mdiLogin,
  mdiCameraPlusOutline: mdiCameraPlusOutline,
  mdiSend: mdiSend,
  mdiContentSave: mdiContentSave,
  mdiChevronRight: mdiChevronRight,
  mdiChevronLeft: mdiChevronLeft,
  mdiChevronUp: mdiChevronUp,
  mdiChevronDown: mdiChevronDown,
  mdiHomeRemoveOutline: mdiHomeRemoveOutline,
  mdiCrop: mdiCrop,
  mdiMapMarker: mdiMapMarker,
  mdiHomePlusOutline: mdiHomePlusOutline,
  mdiHomePlus: mdiHomePlus,
  mdiHomeExportOutline: mdiHomeExportOutline,
  mdiHomeLightbulbOutline: mdiHomeLightbulbOutline,
  mdiHomeGroup: mdiHomeGroup,
  mdiHomeClock: mdiHomeClock,
  mdiAccountOutline: mdiAccountOutline,
  mdiStar: mdiStar,
  mdiHeart: mdiHeart,
  mdiShareVariant: mdiShareVariant,
  mdiPencil: mdiPencil,
  mdiCalendarAccount: mdiCalendarAccount,
  mdiImage: mdiImage,
  mdiCloudUpload: mdiCloudUpload,
  mdiMarker: mdiMarker,
  mdiDeleteEmpty: mdiDeleteEmpty,
  mdiEye: mdiEye,
  mdiEyeOff: mdiEyeOff,
  mdiBell: mdiBell,
  mdiListStatus: mdiListStatus,
  mdiText: mdiText,
  mdiHomeAccount: mdiHomeAccount,
  mdiTimelineQuestion: mdiTimelineQuestion,
  mdiHomeRemove: mdiHomeRemove,
  mdiAccountRemove: mdiAccountRemove,
  mdiMenuDownOutline: mdiMenuDownOutline,
  mdiMap: mdiMap,
  mdiHomeCity: mdiHomeCity,
  mdiHomeAnalytics: mdiHomeAnalytics,
  mdiMagnifyPlus: mdiMagnifyPlus,
  mdiTimelinePlus: mdiTimelinePlus,
  mdiEmail: mdiEmail,
  mdiLock: mdiLock,
  mdiFormatListBulleted: mdiFormatListBulleted,
  mdiMagnify: mdiMagnify,
  mdiChartLine: mdiChartLine,
  mdiNewspaper: mdiNewspaper,
  mdiDelete: mdiDelete,
  mdiFilter: mdiFilter,
  mdiInformation: mdiInformation,
  mdiSkipNext: mdiSkipNext,
  mdiSkipPrevious: mdiSkipPrevious,
  mdiComment: mdiComment,
  mdiCommentOutline: mdiCommentOutline,
  mdiCommentEdit: mdiCommentEdit,
  mdiCommentEditOutline: mdiCommentEditOutline,
  mdiCheckCircle: mdiCheckCircle,
  mdiHeadSyncOutline: mdiHeadSyncOutline,
  mdiRefresh: mdiRefresh,
  mdiMapMarkerQuestionOutline: mdiMapMarkerQuestionOutline,
  mdiBullseye: mdiBullseye,
  mdiChiliHot: mdiChiliHot,
  mdiCharitySearch: mdiCharitySearch,
};

export default icons;
